<h1>Asignar Perfil</h1>
<div class="mat-elevation-z4 divmarco">
  <form [formGroup]="asignarPerfilForm" (ngSubmit)="onSubmit()">
    <h1>Datos de Nuevo Perfil</h1>
    <hr>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese el usuario" appearance="outline" class="input-width-275"
          floatLabel="always">
          <mat-label>Usuario:</mat-label>
          <input matInput formControlName="nombreUsuario" name="nombreUsuario" minlength="3" maxlength="20" autocomplete="off"
            required>
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="asignarPerfilForm.controls['nombreUsuario'].hasError('required')">Usuario es requerido.
          </mat-error>
          <mat-error *ngIf="asignarPerfilForm.controls['nombreUsuario'].hasError('minlength')">Usuario debe ser mínimo 3
            caracteres.
          </mat-error>
          <mat-error *ngIf="asignarPerfilForm.controls['nombreUsuario'].hasError('maxlength')">Usuario debe ser máximo 20
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" appearance="outline" class="input-width-275" floatLabel="always">
          <mat-label>Nuevo Perfil</mat-label>
          <mat-select formControlName="nuevoPerfil" required placeholder="Seleccione una opción">
            <mat-option value="1">Administrador</mat-option>
            <mat-option value="2">Cliente</mat-option>
          </mat-select>
          <mat-icon matSuffix>manage_accounts</mat-icon>
          <mat-error *ngIf="asignarPerfilForm.controls['nuevoPerfil'].hasError('required')">Perfil es requerido.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="divconten">
      <p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
      class="divconten">
      <div fxLayout="column">
        <button mat-raised-button (click)="navigateMenu('home');" color="warn" type="button"
          class="align-center-middle">
          <span class="text-icon-space">Regresar a Home</span>
          <mat-icon>home</mat-icon>
        </button>
      </div>
      <div fxLayout="column">
        <button mat-raised-button color="primary" type="submit" class="align-center-middle">
          <span class="text-icon-space">Asignar Perfil</span>
          <mat-icon>sensor_occupied</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>